// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mRF3","comment":"styles_comment__1z4pT"};